// Brochure table pages, floor plans, and other non-photo project assets
const EXCLUDED_DOCUMENT_IMAGES = new Set([
  '/images/projects/commercial/pallava-granites.jpg',
  '/images/projects/commercial/pharma-warehouse.jpg',
  '/images/projects/residential/residence-mint.jpg',
  '/images/projects/residential/residence-west-tambaram.jpg',
  '/images/projects/residential/residence-west-tambaram-2.jpg',
  '/images/projects/institutional/nalanda-school.jpg',
  '/images/projects/residential/vishalam-builders.jpg'
]);

export const isDisplayableProjectImage = (src) => {
  if (!src) return false;
  return !EXCLUDED_DOCUMENT_IMAGES.has(src);
};

export const filterDisplayableImages = (images = []) =>
  images.filter(isDisplayableProjectImage);

export const filterDisplayableProject = (project) => {
  const images = filterDisplayableImages(project.images || (project.image ? [project.image] : []));
  if (!images.length) return null;
  return { ...project, images };
};

export const HOMEPAGE_CAROUSEL_IMAGES = [
  { src: '/images/projects/residential/residence-ambattur-2.jpg', alt: 'Residence at Ambattur' },
  { src: '/images/projects/residential/residence-kandigai.jpg', alt: 'Residence at Kandigai' },
  { src: '/images/projects/residential/residence-kandigai-2.jpg', alt: 'Residence at Kandigai' },
  { src: '/images/projects/residential/residence-chennai.jpg', alt: 'Residence, Chennai' },
  { src: '/images/projects/residential/row-houses-tdh.jpg', alt: 'Row houses for TDH Homes' },
  { src: '/images/projects/commercial/margheritaly-guest-house.jpg', alt: 'Margheritaly Guest House' },
  { src: '/images/projects/commercial/apartment-sholinganalur.jpg', alt: 'Apartment at Sholinganalur' },
  { src: '/images/projects/commercial/vishalam-builders-1.jpg', alt: 'Vishalam Builders, Kumbakonam' },
  { src: '/images/projects/commercial/kodaikanal-ecoresort.jpg', alt: 'Kodaikanal Ecoresort' },
  { src: '/images/projects/commercial/aachi-cold-storage.jpg', alt: 'Aachi Cold Storage' },
  { src: '/images/projects/institutional/shraddha-academy.jpg', alt: 'Shraddha Academy, Chennai' }
];

export const CM_MAHAL_CAROUSEL_IMAGES = Array.from({ length: 16 }, (_, index) => {
  const number = String(index + 1).padStart(2, '0');
  return {
    src: `/images/cm-mahal/cm-mahal-${number}.png`,
    alt: `CM Mahal - Marriage & Party Hall ${index + 1}`
  };
});

export const CM_MAHAL_GALLERY_PROJECTS = CM_MAHAL_CAROUSEL_IMAGES.map((image, index) => ({
  id: `cm-mahal-${index + 1}`,
  name: '',
  images: [image.src],
  alt: image.alt
}));
